// import { moduleName } from "components/modal/ModalContainer";
// import { blissElement } from "lib/utils/bliss";
import React from "react";
import { connect } from "react-redux";
import UIModalDuck from "stores/ducks/ui/UIModal.duck";
import "./ModalContent.css";

interface IModalContent {
  content?: any;
}

// const elementName = "Content";

const ModalContent = (props: IModalContent) => {
  const { content } = props;
  return (
    <div>
      {content ? content : null}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    content: UIModalDuck.getOwnState(state).content
  };
};

export default connect(mapStateToProps)(ModalContent);



// WEBPACK FOOTER //
// ./src/components/modal/modules/content/ModalContent.tsx